<template>
    <div class="">
        <Card class="">
            <template #title> AltKategoriler</template>
            <template #content>
                <div class="mt-1 mb-2 mr-3">
                    <Button icon="pi pi-plus " size="small" label="Yeni" @click="_AltKategoriModal()" />
                </div>
                <DataTable v-if="DataTable_render" :columns="columns" :data="AltKategoriListesi"
                    v-on:set-child-data="getDataChild" :editbutton="true" />
            </template>
        </Card>

        <Dialog v-model:visible="AltKategoriModal" header="AltKategori"
            :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '25vw' }" modal>

            <div class="formgrid grid ">
                <div class="field col md:col-12">
                    <label for="AltKategoriAd" class="font-bold block">Alt Kategori Ad</label>
                    <InputText id="AltKategoriAd" type="text" v-model="AltKategoriAd"
                        :invalid="this.Valid.AltKategoriAd" class="text-base text-color w-full" />
                </div>
                <div class="field col md:col-12">
                    <label for="Kategori" class="font-bold block">Kategori</label>
                    <Select name="Kategori" v-model="pKategori" :options="KategoriListesi" optionLabel="Ad"
                        optionValue="Kategori_rowid" checkmark :highlightOnSelect="true" fluid
                        :invalid="this.Valid.Kategori" />

                </div>
                <div class="field col md:col-12">
                    <label for="AltKategoriAciklama" class="font-bold block">Açıklama</label>
                    <Textarea id="AltKategoriAciklama" v-model="AltKategoriAciklama" rows="2" cols="30"
                        :invalid="this.Valid.AltKategoriAciklama" class="text-base text-color w-full" />
                </div>
            </div>
            <Divider />
            <div class="flex justify-content-end flex-wrap">
                <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
                    @click="this.handleClick()" autofocus />
                <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
                    @click="this._AltKategoriModal()" />
            </div>
        </Dialog>
    </div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";

export default {
    data() {
        return {
            DataTable_render: true,
            KategoriListesi: [],
            AltKategoriListesi: [],
            columns: [
                { field: "Ad", header: "AltKategori Adı" },
                { field: "Aciklama", header: "Aciklama" },
            ],
            AltKategoriModal: false,
            AltKategoriModelDurum: null,

            AltKategoriAd: "",
            AltKategoriAciklama: "",
            AltKategori_rowid: null,
            Kategori_rowid: "",

            //--------------
            // Validation Elements
            Valid: {
                AltKategoriAd: false,
                AltKategoriAciklama: false,
                Kategori: false,
            }
        };
    },
    methods: {
        getDataChild(getdata_child) {
            this.ResetForm();
            this.AltKategoriModal = !this.AltKategoriModal;
            this.AltKategoriModelDurum = false;
            this.AltKategori_rowid = getdata_child.data.AltKategori_rowid;
            let data = {
                AltKategori_rowid: getdata_child.data.AltKategori_rowid,
            };
            GlobalServis.GlobalServis("POST", "GetAltKategoriInfo", data).then((res) => {
                if (res.status == 200) {
                    this.AltKategoriAd = res.data[0].AltKategoriAd;
                    this.AltKategoriAciklama = res.data[0].Aciklama;
                    this.AltKategoriKod = res.data[0].AltKategori_rowid;

                    this.pKategori = res.data[0].pKategori;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _AltKategoriModal() {
            this.AltKategoriModelDurum = true;
            this.AltKategoriModal = !this.AltKategoriModal;
            if (this.AltKategoriModal === true) {
                this.ResetForm();
            }
        },
        handleClick() {
            if (this._FormCheck()) { return; }

            let data = {
                AltKategori_rowid: this.AltKategori_rowid,
                AltKategoriAd: this.AltKategoriAd,
                AltKategoriAciklama: this.AltKategoriAciklama,
            };
            if (this.AltKategoriModelDurum) {
                // Yeni Kategori
                GlobalServis.GlobalServis("POST", "SetAltKategori", data).then((res) => {
                    if (res.status == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Başarılı",
                            detail: "AltKategori oluşturulmuştur",
                            life: 3000,
                        });
                        this.Refresh();
                        this._AltKategoriModal();
                    } else if (res.response.status === 999) {
                        this.$toast.add({
                            severity: "warn",
                            summary: "Uyarı",
                            detail: res.response.data,
                            life: 3000,
                        });
                    } else {
                        this.$toast.add({
                            severity: "error",
                            summary: "Hata",
                            detail: "Hata oldu",
                            life: 3000,
                        });
                    }
                }).then(() => {
                });
            } else {
                // Edit AltKategori
                GlobalServis.GlobalServis("POST", "UpdateAltKategori", data).then((res) => {
                    if (res.status == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Başarılı",
                            detail: "AltKategori düzenlemiştir",
                            life: 3000,
                        });
                        this.Refresh();
                        this._AltKategoriModal();
                    } else if (res.response.status === 999) {
                        this.$toast.add({
                            severity: "warn",
                            summary: "Uyarı",
                            detail: res.response.data,
                            life: 3000,
                        });
                    } else {
                        this.$toast.add({
                            severity: "error",
                            summary: "Hata",
                            detail: "Hata oldu",
                            life: 3000,
                        });
                    }
                }).then(() => {
                });
            }

        },
        Refresh() {
            this.DataTable_render = false;
            this.$nextTick(() => {
                this.InitServis();
                this.DataTable_render = true;
            });
        },
        ResetForm() {
            this.AltKategoriAd = "";
            this.AltKategoriAciklama = "";
            this.AltKategori_rowid = null;
        },
        _FormCheck() {
            let Check = false;
            if (this.AltKategoriAd === "") {
                this.Valid.AltKategoriAd = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "AltKategori adı girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.AltKategoriAd = false; Check = false; }

            if (this.pKategori === "") {
                this.Valid.Kategori = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kategori seçin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.Kategori = false; Check = false; }


            if (this.AltKategoriAciklama === "") {
                this.Valid.AltKategoriAciklama = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Açıklama girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.AltKategoriAciklama = false; Check = false; }

            return Check;
        },
        GetAltKategoriTablosu() {
            GlobalServis.GlobalServis("GET", "GetAltKategoriTablosu", "").then((res) => {
                if (res.status == 200) {
                    this.AltKategoriListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetKategori() {
            GlobalServis.GlobalServis("GET", "GetKategoriTablosu", "").then((res) => {
                if (res.status == 200) {
                    this.KategoriListesi = res.data;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        }
    },
    mounted() {
        this.GetAltKategoriTablosu();
        this._GetKategori();
    },
    components: {
        DataTable,
    },
};
</script>